export default {"src":"/_next/static/media/icon-star.c461c633.svg","height":38,"width":40,"blurWidth":0,"blurHeight":0};